import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, RouterModule } from '@angular/router';
import { QuestionService } from '../../services/question.service';
import { UserService } from '../../services/user.service';
import { Question } from '../../models/question.model';
import { QuestionComponent } from '../../shared/components/question/question.component';
import { NgFor, NgIf } from '@angular/common';

@Component({
  selector: 'app-unique-question-page',
  templateUrl: './unique-question-page.component.html',
  standalone: true,
  imports: [QuestionComponent, NgFor, NgIf, RouterModule],
  styleUrls: ['./unique-question-page.component.css']
})
export class UniqueQuestionPageComponent implements OnInit {
  qcode!: string;
  questions: Question[] = [];
  isLoading: boolean = true;
  plan: string = '';
  userId = Number(localStorage.getItem('id'));

  constructor(
    private route: ActivatedRoute,
    private questionService: QuestionService,
    private userService: UserService,
  ) {}

  ngOnInit() {
    this.qcode = this.route.snapshot.paramMap.get('qcode') || '';

    // Primeiro pegar o plano do usuário
    this.userService.getUserPlan(this.userId).subscribe({
      next: (res) => {
        this.plan = res.plan;

        if (this.plan.toLowerCase() === 'free') {
          // Se free, não carrega perguntas
          this.isLoading = false;
        } else {
          // Senão, carrega perguntas
          this.loadQuestions();
        }
      },
      error: (err) => {
        console.error('Erro ao carregar plano do usuário:', err);
        this.isLoading = false;
      }
    });
  }

  loadQuestions() {
    this.questionService.getQuestions(this.userId, '').subscribe({
      next: (response: any) => {
        const questionData = response.questions.data;
        const matchedQuestion = questionData.find((q: any) => q.code === this.qcode);

        if (matchedQuestion) {
          this.questions = [matchedQuestion];
        } else {
          console.error('Pergunta não encontrada para o código:', this.qcode);
        }

        this.isLoading = false;
      },
      error: (error) => {
        console.error('Erro ao carregar as perguntas:', error);
        this.isLoading = false;
      }
    });
  }
}
